import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UpdateGridRowDto } from 'src/app/interfaces/Dtos/grid-data.dto';
import { ControltowerService } from '../dashboards/controltower.service';
import { storageApiDto } from 'src/app/interfaces/Dtos/storage-api.dto';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable() 
export class BlobStorageUrlService {
  public continentResponse: string = "";

  constructor(private controlTowerService: ControltowerService) {
  }

  private GetStorageByContinent(continent: string, configParamStorages: any) {
    var storage = configParamStorages.find((x: any) => x.continent == continent)
    if (storage == undefined) {
      storage = configParamStorages.find((x: any) => x.continent == 'Global')
    }
    return storage
  }

  public async GetBlobStorageUrlApi() {

    var sitesId = localStorage.getItem('site').split(',')
    var location = localStorage.getItem('location')

    if(location == undefined){
      location = null;
    }

    console.log("location_TEST", location)

    if (location == null) {
      var cordinates = await this.getNavegatorLocation(sitesId)
      var continent = await this.getContinentFromCoordinates(cordinates.latitude, cordinates.longitude)

      localStorage.setItem('location', continent)
      console.log("1", location)
      var configParamStorages = await this.getConfigParamsStorages(sitesId)
      return this.GetStorageByContinent(continent, configParamStorages)

    } else {
      console.log("2", location)
      var configParamStorages = await this.getConfigParamsStorages(sitesId)
      return this.GetStorageByContinent(location, configParamStorages)
    }
  }

  private async getNavegatorLocation(sitesId: any): Promise<{ latitude: number; longitude: number }> {
    console.log("getNavegatorLocation")
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('La geolocalización no está disponible en este navegador.');
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {

          console.log("getNavegatorLocation resolve");

          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })
        },
        (error) => reject(error.message)
      );
    });
  }

  private getContinentFromCoordinates(latitude: number, longitude: number): Promise<string> {
    console.log("getContinentFromCoordinates")
    const apiKey = 'a765ea2de25b4a288eca77445570a49d';
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    return fetch(url)
      .then((response) => response.json())
      .then((data) => data.results[0].components.continent);
  }

  private async getConfigParamsStorages(sitesId: any): Promise<any> {
    console.log("getConfigParamsStorages")
    var storageApiDto: storageApiDto = {
      sitesId: sitesId
    }
    return new Promise<boolean>((resolve, reject) => {
      this.controlTowerService.getStorageApiBySite(storageApiDto).subscribe(
        {
          next: (data: any) => {

            console.log("getConfigParamsStorages resolve");

            resolve(data);
          }, error: (error: HttpErrorResponse) => {
            resolve(undefined);
          }
        }
      )
    });
  }
}